import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CardGridTemplate } from './card-grid.template';
import { FilterableService } from '../filterable-service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'card-grid',
  templateUrl: './card-grid.component.html',
  styleUrls: ['./card-grid.component.scss']
})
export class CardGridComponent implements OnInit {
  orderByData: any[];
  orderBy: any = {};
  searchValue: string;
  data: FilterableService;

  @Input() set template(obj: CardGridTemplate) {
    if (obj && obj.orderByData) {
      this.data = obj.data;
      this.orderByData = obj.orderByData;
      this.orderBy = (obj.orderBy || obj.orderByData[0]);
      if (this.data) {
        this.reorder(this.orderBy);
        this.data.subscribe(x => {
          if (x) {
            this.filter();
            this.reorder(this.orderBy);
          }
        });
      }
    }
  }

  @Output() search: EventEmitter<any> = new EventEmitter<any>();

  constructor() {
    //this is kept empty on purpose
  }

  ngOnInit() {
    //this is kept empty on purpose
  }

  reorder(orderBy: string) {
    if (this.data.filteredData.value) {
      const result = this.data.filteredData.value;
      result.sort((a, b) => {
        return this.handleSort(a, b);
      });
      this.data.filteredData.next(result);
    }
  }


  filter() {
    if (this.data) {
      this.data.handleFilter(this.searchValue);
    }
  }

  private handleSort(a, b): number {
    const checkA = a[this.orderBy.value];
    const checkB = b[this.orderBy.value];
    return this.orderBy.dir === 'asc' ?
      checkA < checkB ? -1 : checkA > checkB ? 1 : 0 :
      checkB < checkA ? -1 : checkB > checkA ? 1 : 0;
  }

}
